import tokenData from '../../design-tokens/base-tokens.json';
export const MuiSvgIcon = {
    styleOverrides: {
        fontSizeSmall: ({ theme }) => ({
            ...theme.typography.iconSm
        }),
        fontSizeMedium: ({ theme }) => ({
            ...theme.typography.icon
        }),
        fontSizeLarge: ({ theme }) => ({
            ...theme.typography.iconLg
        })
    }
};
export const MuiIcon = {
    styleOverrides: {
        colorDisabled: {
            color: tokenData.tokens.palette.grey.disabled
        }
    }
};
